import * as React from 'react';
import { Alert, Typography } from '@mui/material';
import { estimateMarketingPushAudience } from '../../Api';
import type { PushAudienceRequest, PushAudienceEstimate as Estimate } from '../../models/dtos/MarketingPushDto';

export default function PushAudienceEstimate({audience}: {audience:PushAudienceRequest}) {
    const [result,setResult]=React.useState<Estimate|null>(null);
    const [error,setError]=React.useState('');
    const [loading,setLoading]=React.useState(false);
    const key=JSON.stringify(audience);
    React.useEffect(()=>{
        let live=true;
        const request:PushAudienceRequest=JSON.parse(key);
        setResult(null);setError('');setLoading(request.userTags.length>0);
        if(!request.userTags.length)return;
        const timer=window.setTimeout(async()=>{
            try {const response=await estimateMarketingPushAudience(request);if(!live)return;
                if(response.ok)setResult(response.data);else setError(response.error);
            }catch {if(live)setError('Audience estimate is unavailable.');}
            finally {if(live)setLoading(false);}
        },400);
        return()=>{live=false;window.clearTimeout(timer);};
    },[key]);
    if(!audience.userTags.length)return <Typography variant="body2">Select tags to estimate the audience.</Typography>;
    if(error)return <Alert severity="warning">{error}</Alert>;
    return <Alert severity="info">{loading||!result?'Estimating matching users…':<>Approximately {result.totalUsers.toLocaleString()} matching users{audience.maxUsers?` · up to ${result.estimatedRecipients.toLocaleString()} after the user limit`:''}. This estimate excludes token availability and recent-send suppression; the audience is evaluated again at dispatch.</>}</Alert>;
}
